import { Fragment } from "react";
import { createConditionTree } from "../utils/createConditionTree";
import { heightOfNode } from "../utils/heightOfNode";
import { membershipConditionErrorResponse } from "../utils/validateMembershipCondition";
import ConditionNode from "./ConditionNode";
import "./index.css";
import { MembershipConditionsErrors } from "./MembershipConditionErrors";
import { Operators } from "./Operators";

class MultiOperandComplexCondition extends ConditionNode {
  operandKey = "operands";
  addOperands(operands) {
    operands?.forEach((operand) => {
      let operandCondition = createConditionTree(operand, this);
      this[this.operandKey].push(operandCondition);
    });
  }
  isSingleOperand() {
    return false;
  }
  getOperands() {
    return this[this.operandKey];
  }
  toJSON(requestFormat = false) {
    const listOfOperands = [];
    this[this.operandKey].forEach((operand) => {
      listOfOperands.push(operand.toJSON(requestFormat));
    });
    let jsonResponse = {
      operator: this.operator,
      operands: listOfOperands,
    };
    if (requestFormat === false) {
      jsonResponse = {
        ...jsonResponse,
        id: this.key,
        pathFromRoot: this.pathFromRoot,
        isKeyCondition: this.isKeyCondition,
      };
    }
    return jsonResponse;
  }
}

export class Conjunction extends MultiOperandComplexCondition {
  operator = Operators.logicalAND;
  constructor(condition, parentNode) {
    super(condition.id, condition.pathFromRoot, parentNode);
    this.setIsKeyCondition();
    this[this.operandKey] = [];
    this.addOperands(condition[this.operandKey]);
  }
  setIsKeyCondition() {
    if (heightOfNode(this) < 2) {
      this.isKeyCondition = true;
    }
  }
  render() {
    const operands = this.getOperands();
    return (
      <div className="and-condition">
        {operands.map((operand, index) => {
          return (
            <Fragment key={operand.key}>
              {operand.render()}
              {operands.length - 1 !== index ? (
                <span className="and-operator-name">AND</span>
              ) : null}
            </Fragment>
          );
        })}
      </div>
    );
  }

  renderAsString() {
    const operands = this.getOperands();
    return (
      <div className="and-condition-string">
        {operands.map((operand, index) => {
          return (
            <Fragment key={operand.key}>
              {operand.renderAsString()}
              {operands.length - 1 !== index ? (
                <span className="and-operator-name-string">AND</span>
              ) : null}
            </Fragment>
          );
        })}
      </div>
    );
  }

  returnMembershipConditionErrorCode() {
    let errorCode, message;
    if (heightOfNode(this) > 1) {
      errorCode = MembershipConditionsErrors.ConjunctionAboveHeight1.errorCode;
      message = MembershipConditionsErrors.ConjunctionAboveHeight1.message;
    }
    return membershipConditionErrorResponse(errorCode, this.key, message);
  }
}

export class Disjunction extends MultiOperandComplexCondition {
  operator = Operators.logicalOR;
  constructor(condition, parentNode) {
    super(condition.id, condition.pathFromRoot, parentNode);
    this[this.operandKey] = [];
    this.addOperands(condition[this.operandKey]);
  }
  returnMembershipConditionErrorCode() {
    let errorCode, message;
    if (heightOfNode(this) > 0) {
      errorCode = MembershipConditionsErrors.DisjunctionAboveHeight0.errorCode;
      message = MembershipConditionsErrors.DisjunctionAboveHeight0.message;
    }
    return membershipConditionErrorResponse(errorCode, this.key, message);
  }
}

class SingleOperandComplexCondition extends ConditionNode {
  operandKey = "operand";
  getOperands() {
    return this[this.operandKey];
  }
}

export class Negation extends SingleOperandComplexCondition {
  operator = Operators.logicalNOT;
  constructor(condition, parentNode) {
    super(condition.id, condition.pathFromRoot, parentNode);
    this[this.operandKey] = condition[this.operandKey];
  }
  returnMembershipConditionErrorCode() {
    return membershipConditionErrorResponse(
      MembershipConditionsErrors.NotSupportedOperators.errorCode,
      this.key,
      MembershipConditionsErrors.NotSupportedOperators.message
    );
  }
}
